import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    logs_getAll() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'logs/get-all')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    }
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};